import { ICON_CHECK_CIRCLE_FILL_GREEN } from '@repo/assets';
import styled from 'styled-components';

type Props = {
  isDisplay: boolean;
  text: string;
};

export const Toast = ({ isDisplay, text }: Props) => {
  return (
    <Wrapper $isDisplay={isDisplay}>
      <ImgBadge src={ICON_CHECK_CIRCLE_FILL_GREEN} alt='' />
      <Text>{text}</Text>
    </Wrapper>
  );
};

const Wrapper = styled.div<{ $isDisplay: boolean }>`
  position: fixed;
  top: -100px;
  left: 20px;
  right: 20px;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  border-radius: 4px;
  background: #3a3b3e;
  transform: ${({ $isDisplay }) => $isDisplay && 'translateY(110px)'};
  transition: all 0.8s;
  z-index: 200;
`;

const ImgBadge = styled.img`
  display: block;
  width: 24px;
`;

const Text = styled.p`
  color: var(--KTP-Grayscale-Gray_14, #fff);
  font-size: 14px;
  font-weight: 600;
  line-height: 150%;
  letter-spacing: -0.28px;
`;
